import { tenantFormFields } from 'src/utils/constants';
import { AddOrEditGroupsProps } from './types';

export const getAddOrEditPayload = (formData: AddOrEditGroupsProps) => ({
  name: formData[tenantFormFields.NAME as keyof AddOrEditGroupsProps],
  criteria: [
    formData[tenantFormFields.OPERATOR_ID as keyof AddOrEditGroupsProps]?.length
      ? {
          criteriaType: 'OPERATOR',
          criteriaValues: [
            ...(formData[
              tenantFormFields.OPERATOR_ID as keyof AddOrEditGroupsProps
            ] as string[]),
          ],
        }
      : null,
    formData[tenantFormFields.STATE as keyof AddOrEditGroupsProps]?.length
      ? {
          criteriaType: 'STATE',
          criteriaValues: [
            ...(formData[
              tenantFormFields.STATE as keyof AddOrEditGroupsProps
            ] as string[]),
          ],
        }
      : null,
    formData[tenantFormFields.SITES as keyof AddOrEditGroupsProps]?.length
      ? {
          criteriaType: 'SITE',
          criteriaValues: [
            ...(formData[
              tenantFormFields.SITES as keyof AddOrEditGroupsProps
            ] as string[]),
          ],
        }
      : null,
    formData[tenantFormFields.ALL_SITES as keyof AddOrEditGroupsProps]
      ? {
          criteriaType: 'CUSTOMER',
          criteriaValues: [
            formData[
              tenantFormFields.CUSTOMER_ID as keyof AddOrEditGroupsProps
            ],
          ],
        }
      : null,
    formData[tenantFormFields.COUNTRY_CRITERIA as keyof AddOrEditGroupsProps]
      ?.length
      ? {
          criteriaType: 'COUNTRY',
          criteriaValues: [
            ...(formData[
              tenantFormFields.COUNTRY_CRITERIA as keyof AddOrEditGroupsProps
            ] as string[]),
          ],
        }
      : null,
  ].filter(criteria => !!criteria),
  customerId:
    formData[tenantFormFields.CUSTOMER_ID as keyof AddOrEditGroupsProps],
  timeZoneOffset:
    formData[
      tenantFormFields.TIMEZONE_UTCOFFSET_STR as keyof AddOrEditGroupsProps
    ],
  timeZoneId:
    formData[tenantFormFields.TIMEZONE_ID as keyof AddOrEditGroupsProps],
  address: {
    countryCode:
      formData[tenantFormFields.COUNTRY_CODE as keyof AddOrEditGroupsProps],
    city: formData[tenantFormFields.CITY as keyof AddOrEditGroupsProps],
    address1: formData[tenantFormFields.ADDRESS1 as keyof AddOrEditGroupsProps],
    state:
      formData[tenantFormFields.STATE_ADDRESS as keyof AddOrEditGroupsProps],
  },
});
